const getMemberFullName = (enrollment) => `${enrollment?.member?.contact?.first_name || ''} ${enrollment?.member?.contact?.last_name || ''}`.trim() ||
    `${enrollment?.contact?.first_name || ''} ${enrollment?.contact?.last_name || ''}`.trim();
export default getMemberFullName;
